<template>
  <section>
    <app-general :publication="publication" ></app-general>
  </section>
</template>
<script>
import general from './General.vue';

export default {
    props:['publication'],
    components:{
        AppGeneral:general,
    },
}
</script>
